import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import React, { useId } from "react";
import Icon, { IconTypes } from "shared/ui/icon";

const MotionIcon = motion(Icon);

type WidthProps = {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
  description: React.ReactNode;
  disabled?: boolean;
};

export const WidthSelectorCard = ({
  isActive,
  onClick,
  children,
  description,
  disabled,
}: WidthProps) => {
  const descriptionId = useId();
  return (
    <div className="gg-flex gg-flex-col gg-space-y-2.5">
      <button
        type="button"
        aria-labelledby={descriptionId}
        aria-pressed={isActive}
        onClick={onClick}
        disabled={disabled}
        className={classNames(
          "gg-relative gg-grid gg-aspect-square gg-w-20 gg-place-items-center gg-rounded gg-border gg-transition gg-duration-300 gg-ease-in-out hover:gg-border-[#9493A3] sm:gg-w-[120px] lg:gg-w-[85px] xl:gg-w-[120px] 2xl:gg-w-[125px]",
          {
            "gg-border-[#9493A3] gg-bg-[#fff]": isActive,
            "gg-border-[#EAE9ED] gg-bg-white": !isActive,
          },
        )}
      >
        <AnimatePresence>
          {isActive && (
            <MotionIcon
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0 }}
              transition={{ duration: 0.28, ease: "easeInOut" }}
              name={IconTypes.WHITE_CHECK}
              alt=""
              className={`gg-absolute -gg-top-2.5 gg-left-full gg-z-10 gg-aspect-square gg-w-5 -gg-translate-x-2.5 gg-rounded-full gg-bg-green-500 gg-p-1.5`}
            />
          )}
        </AnimatePresence>
        {children}
      </button>

      <div id={descriptionId} className="gg-w-20 sm:gg-w-auto">
        {description}
      </div>
    </div>
  );
};
